import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "gmp_admin_token";

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const galleryFileUrl = (id) => `${API}/gallery/file/${id}`;

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return String(d);
}
